module.exports = new __parcel__URL__("foodigy-logo-transparent.55828790.png").toString();